import React from "react";
import classes from "./item.module.scss";

function Item(props) {
  return (
    <li className={classes.item}>
      <div className={classes.img__wrapper}>
        <img className={classes.img} src={props.srcImg} alt="chemical" />
      </div>
      <div className={classes.description__wrapper}>
        <div>
          <h2 className={classes.title}> {props.title}</h2>
          <p className={classes.description}>{props.description}</p>
        </div>
        <div className={classes.maxAmount}>
          <span>Максимальна концентрація: </span> {props.maxAmount}
        </div>
      </div>
      <div className={classes.danger__wrapper}>
        <div>
          <h2 className={classes.title}>Вплив на людину</h2>
          <p className={classes.danger}>{props.danger}</p>
        </div>
        <div className={classes.danger__type}>
          <span>Небезпечність: {props.dangerType}</span>
        </div>
      </div>
    </li>
  );
}

export default Item;
